import { Injectable} from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as uuid from 'uuid';

const file_extension = (filename: string) => {
  let match;
  if (match = /[^.]+$/.exec(filename)) {
    return match[0]
  }
  return '';
}

@Injectable({providedIn: 'root'})
export class AWSUploadService {

  constructor(private http: HttpClient) { }

  upload(files: any, directory: string): Observable<any> {
    const file = files[0] ? files[0] : files;
    const metadata: any = {};
    metadata.filename = directory + '/' + uuid.v4() + '.' + file_extension(file.name);
    metadata.filepath = directory;
    metadata.filetype = file.type;
    return this.http.post<any>('presign', metadata).pipe(
      switchMap(resp => {
        const fields = resp.data.fields;
        const formData = new FormData();
        for (const key in fields) {
          if (fields.hasOwnProperty(key)) {
            formData.append(key, fields[key]);
          }
        }
        formData.append('file', file, fields.key);
        file.description = file.name;
        return this._upload(resp.data.url, formData, file);
      })
    );
  }

  private _upload(url: string, formData: FormData, file?: File): Observable<any> {
    return this.http.post<any>(url, formData, { observe: 'events', reportProgress: true })
      .pipe(map((event: any): any => {
        let progress;
        switch (event.type) {
          case HttpEventType.UploadProgress:
            progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', progress, url , ...file};
          case HttpEventType.Response:
            return { status: 'complete', progress: 100, url: `${url}/${formData.get('key')}` , ...file};
        }
      })
    );
  }

}
